<template>
    <div class="rsv_updates left_panel_item loading_top_wrap" @click="action_ClickBackground">
        <div v-if="isLoading" class="loading_bg round_none transparent" style="z-index: 100;">
            <div class="loading_wrap">
                <div class="loading_obj">
                    <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66"
                         xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33"
                                r="30"></circle>
                    </svg>
                </div>
            </div>
        </div>
        <div class="left_panel_title">
            <div class="title_wrapper">
                <span class="title rsv_count">{{ $t('reservationwindow.leftpannel.label_reservation') }}: <strong>{{ sumReservationCount }}</strong></span>
                <span class="title cancel_count">{{ $t('reservationwindow.leftpannel.label_cancel') }}: <strong>{{ cancelReservationCount }}</strong></span>
            </div>
            <button class="btn_white btn_round mgl_auto" @click="action_ShowMonitorPopup">{{ $t('reservationwindow.leftpannel.button_seeall_title') }}</button>
        </div>
        <div v-if="hasAiGroup" class="rsv_detail ai_rsv_confirm_wait">
            <div class="title">AI 예약 확정대기</div>
            <div class="count">{{ aiReservationCount }}</div>
        </div>

        <div class="rsv_detail_wrapper">
            <div class="rsv_detail">
                <div class="title">직원예약</div>
                <div class="count">{{ hworkerReservationCount }}</div>
            </div>
            <div class="rsv_detail">
                <div class="title">환자예약</div>
                <div class="count">{{ userReservationCount }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
import { mapState } from 'vuex'
import { showMonitorPopup } from '../../../sheet-overlays'
import { exitTimeSelectMode } from '../../../reservation-selection'
import { sheetAxis } from '../../../sheet-axis'
import { selectedColumns, selectedStates, selectedGroups, hasAiGroup } from '../../../sheet-filters'
import { sheetRefresh } from '../../../sheet-refresh'
import { useQueryClient } from '@tanstack/vue-query'
import { statsV2ReservationDailyFindQueryOptions } from '@/composables/queries/stats/use-stats-v2reservation-daily-find-query'
import { aiReservationCountQueryOptions } from '@/composables/queries/aireservation/use-ai-reservation-count-query'
import { isApiErrorWithCode } from '@/apis/instances/check-api-response'

const moment = require('@/util/MPMoment')
export default {
    setup() {
        const queryClient = useQueryClient()
        return { queryClient }
    },
    props: {},
    data() {
        return {
            sheetAxis,
            sheetRefresh,
            isLoading: false,

            statResultObj: {},
            aiReservationConfirmedCount: 0
        }
    },
    watch: {
        'sheetRefresh.refreshFlagMoment': {
            deep: true,
            handler: 'requestStats'
        },
        'sheetRefresh.reservationRefreshEvent': {
            handler: 'requestStats'
        },
        selectedColumns: {
            deep: true,
            handler: 'requestStats'
        },
        selectedStates: {
            deep: true,
            handler: 'requestStats'
        },
        selectedGroups: {
            deep: true,
            handler: 'requestStats'
        }
    },
    computed: {
        ...mapState(['SaaS']),
        selectedDate: function () {
            return this.sheetAxis.selectedDate
        },
        selectedGroups: function () {
            return selectedGroups()
        },
        selectedColumns: function () {
            return selectedColumns().filter(c => this.selectedGroups.some(g => g._id == c.groupID))
        },
        selectedStates: function () {
            return selectedStates()
        },
        userReservationCount: function () {
            return this.statResultObj?.userReservationCount ?? 0
        },
        aiReservationCount: function () {
            return this.aiReservationConfirmedCount;
        },
        hworkerReservationCount: function () {
            let count = (this.statResultObj?.hworkerReservationCount ?? 0) - (this.aiReservationCount ?? 0);
            if (this.isSaaSWindow == true) {
                count += this.anurseReservationCount
            }
            return count < 0 ? 0 : count
        },
        anurseReservationCount: function () {
            return this.statResultObj?.anurseReservationCount ?? 0
        },
        sumReservationCount: function () {
            return this.statResultObj?.sumReservationCount ?? 0
        },
        cancelReservationCount: function () {
            return this.statResultObj?.cancelReservationCount ?? 0
        },
        hasAiGroup: function () {
            return hasAiGroup()
        },
        isSaaSWindow: function() {
            return this.SaaS.isWindow
        }
    },
    mounted() {
        this.requestStats()
    },
    methods: {
        action_ClickBackground() {
            exitTimeSelectMode()
        },
        action_ShowMonitorPopup() {
            showMonitorPopup()
        },

        async requestStats() {
            await this.requestFetchReservationDailyStatus()
            await this.requestFetchAiReservationConfirmedCount()
        },

        async requestFetchReservationDailyStatus() {
            try {
                this.isLoading = true
                const columnIds = this.selectedColumns.map(c => c._id)
                const stateIds = this.selectedStates.map(s => s._id)

                if (columnIds.length == 0 || stateIds.length == 0 || this.selectedGroups.length == 0) {
                    this.statResultObj = {}
                    return
                }

                let param = {
                    hospitalID: this.hospital.selectedHospital._id,
                    columnID: columnIds,
                    statusID: stateIds,
                    startDate: moment(this.selectedDate).startOf('day').toString(),
                    endDate: moment(this.selectedDate).endOf('days').toString()
                }
                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                const data = await this.queryClient.fetchQuery(statsV2ReservationDailyFindQueryOptions(param));
                this.requestFetchReservationDailyStatusCallback(data)
            } catch (err) {
                this.statResultObj = {}
                console.log('daily reservation monitor find error', err)
            } finally {
                this.isLoading = false
            }
        },
        async requestFetchAiReservationConfirmedCount() {
            let countResult
            try {
                countResult = await this.queryClient.fetchQuery(aiReservationCountQueryOptions({
                    hospitalID: this.hospital.selectedHospital._id,
                    status: 'pending',
                    startedAt: moment(this.selectedDate).startOf('days').toString(),
                    endedAt: moment(this.selectedDate).endOf('days').toString()
                }))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 조용히 중단
                if (!isApiErrorWithCode(err)) throw err
                return
            }
            this.aiReservationConfirmedCount = countResult.count
        },
        requestFetchReservationDailyStatusCallback(data) {
            this.statResultObj = {}
            for (let i = 0; i < data.length; i++) {
                const d = data[i]
                this.statResultObj.userReservationCount = (this.statResultObj?.userReservationCount ?? 0) + (d?.userReservationCount ?? 0);
                this.statResultObj.hworkerReservationCount = (this.statResultObj?.hworkerReservationCount ?? 0) + (d?.hworkerReservationCount ?? 0);
                this.statResultObj.anurseReservationCount = (this.statResultObj?.anurseReservationCount ?? 0) + (d?.anurseReservationCount ?? 0);
                this.statResultObj.sumReservationCount = (this.statResultObj?.sumReservationCount ?? 0) + (d?.sumReservationCount ?? 0);
                this.statResultObj.cancelReservationCount = (this.statResultObj?.cancelReservationCount ?? 0) + (d?.cancelReservationCount ?? 0);
            }
            this.statResultObj = deepCopy(this.statResultObj)
        }
    },
}
</script>
<style scoped>
.left_panel_title {
    margin-bottom: 10px;
}

.left_panel_title .title_wrapper {
    display: flex;
    gap: 10px;
}

.left_panel_title .title_wrapper .title {
    color: #858585;
}
.left_panel_title .title_wrapper .title.rsv_count strong {
    color: #1F8FE5;
}
.left_panel_title .title_wrapper .title.cancel_count strong {
    color: #FF5C71;
}

.rsv_detail_wrapper {
    display: flex;
    gap: 5px;
}

.rsv_detail {
    display: flex;
    align-items: center;
    font-size: 12px;
}

.rsv_detail .count {
    position: relative;
    margin-left: auto;
    width: 50px;
    padding-right: 15px;
    padding-left: 10px;
    color: #222;
    font-weight: bold;
}

.rsv_detail .count::before {
    content:'';
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 1px;
    height: 20px;
    background: #ccc;
}


.rsv_detail {
    width: 100%;
    height: 36px;
    display: flex;
    border-radius: 8px;
    border: 1px solid #DFDFE0;
    background-color: #F2F2F3;
}

.rsv_detail .title {
    padding-left: 15px;
}

.rsv_detail.ai_rsv_confirm_wait {
    margin-bottom: 5px;
    justify-content: space-between;
    border: 1px solid #74BEFF;
    background-color: #F5F7FF;
    color: #1F8FE5;
}

.rsv_detail.ai_rsv_confirm_wait .count {
    color: #1F8FE5;
}

.ai_rsv_confirm_wait .title {
    padding-left: 15px;
    font-weight: 500;
}

.ai_rsv_confirm_wait .count {
    padding-right: 15px;
}
</style>